import { render, staticRenderFns } from "./VideoPromo.vue?vue&type=template&id=017de2e6"
import script from "./VideoPromo.vue?vue&type=script&lang=js"
export * from "./VideoPromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports